import React, { useState, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import queryString from 'query-string';
import i18next from 'i18next';
import { useTranslation } from 'react-i18next';

import { SectionCompareStatistics } from 'lib/api/report';

import FilterWrap from 'components/atoms/FilterWrap';
import TableContainer from 'components/molecules/MbTable';
import Popover from 'components/molecules/Popover';
import StatisticsCommonFilter from 'components/organisms/StatisticsCommonFilter';

import StatisticsGraph from './StatisticsGraph';

let initialization = false;

const typeList = [
  {
    label: i18next.t('소진'),
    value: 'advrtsAmt',
  },
  {
    label: i18next.t('CTR'),
    value: 'clickRate',
  },
  {
    label: i18next.t('노출'),
    value: 'parEprsCnt',
  },
  {
    label: i18next.t('ECPM'),
    value: 'ecpm',
  },
];

let initParam = { type: 'advrtsAmt' };
let closePopover = null;

const Statistics = ({ location }) => {
  const { t } = useTranslation();
  const { isPop } = queryString.parse(location.search);
  const [type, setType] = useState('advrtsAmt');
  const { mediaScriptNo } = queryString.parse(location.search);
  if (typeof mediaScriptNo !== 'undefined')
    initParam.mediaScriptNo = mediaScriptNo;

  // 공통 필터에서 초기값 받아왔는지 확인
  const [getInitParam, setGetInitParam] = useState(false);
  const [params, setParams] = useState(initParam);

  //   let typeText;
  //   switch (type) {
  //     case 'advrtsAmt':
  //       typeText = '지출금액';
  //       break;
  //     case 'clickRate':
  //       typeText = 'CTR';
  //       break;
  //     case 'parEprsCnt':
  //       typeText = '노출';
  //       break;
  //     case 'ECPM':
  //       typeText = 'ECPM';
  //       break;
  //     default:
  //       typeText = '지출금액';
  //       break;
  //   }

  useEffect(() => {
    // 렌더링 후에 실행됨
    // params setting(필터링 혹은 초기 param setting) > 렌더링 > 초기화 값 초기화
    initialization = false;
  }, [params]);

  // header 및 body 컬럼 커스텀
  const customized = {};

  /**
   * 필터창 닫는 핸들링 받아오는 함수
   */
  const getOnClose = (handleClose) => {
    closePopover = handleClose;
  };

  const childColumnSet = {
    ADVER_ID: () => {
      return null;
    },
  };

  /**
   * 테이블 클릭 후 세부정보 받아올때 보낼 param setting 해주는 함수
   * @param {json} data 테이블 로우 데이터
   */
  const makeSubParam = (data) => {
    return {
      adverId: data.ADVER_ID,
    };
  };

  /**
   * 필터 초기화
   */
  const handleOnReset = () => {
    initialization = true;
    setParams(initParam);
  };

  const getParam = (newParams) => {
    if (getInitParam === false) {
      initParam = {
        ...initParam,
        ...newParams,
      };
    }
    setGetInitParam(true);
    setParams({
      ...params,
      ...newParams,
    });
  };

  /**
   * 타입구분
   * @param {object} e
   */
  const handleOnCode = (e) => {
    const { value } = e.target;
    const newParams = {
      ...params,
    };

    newParams[e.target.name] = value;
    setType(value);
    setParams(newParams);
    closePopover();
  };

  return (
    <>
      <FilterWrap handleOnReset={handleOnReset}>
        <StatisticsCommonFilter
          initialization={initialization}
          getParam={getParam}
          initData={initParam}
          useDiffDate={true}
        />
        <Popover
          name="type"
          label={t('구분')}
          getOnClose={getOnClose}
          selectedLabel={type}
          // filtered={pltfomTpCode !== '00'}
          filterType="radio"
          optionSelectedValue={type}
          optionList={typeList}
          optionOnChange={handleOnCode}
        />
      </FilterWrap>
      {getInitParam && (
        <>
          {typeof isPop === 'undefined' ? <StatisticsGraph /> : ''}
          <TableContainer
            dataReqPromise={SectionCompareStatistics}
            params={{ ...params }}
            sort="desc"
            order="ADVRTS_AMT"
            dense={true}
            hasExcel
            hasTotal
            customized={customized}
            expandTable
            makeSubParam={makeSubParam}
            childColumnSet={childColumnSet}
          />
        </>
      )}
    </>
  );
};

export default withRouter(Statistics);
